import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS } from "../lib/site";

export default function FAQ({ items = FAQS }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {items.map((f, i) => (
        <AccordionItem key={i} value={`faq-${i}`} className="border-line">
          <AccordionTrigger
            data-testid={`faq-question-${i}`}
            className="text-left font-display font-bold text-navy text-base sm:text-lg hover:text-saffron hover:no-underline py-5"
          >
            {f.q}
          </AccordionTrigger>
          <AccordionContent data-testid={`faq-answer-${i}`} className="text-slate-600 leading-relaxed text-[15px] pb-5">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
